import { createClient } from '@supabase/supabase-js';

// Hardcoded credentials (override .env if needed)
const HARDCODED_SUPABASE_URL = 'https://ziubepyopztwveanglxk.supabase.co';
const HARDCODED_SUPABASE_ANON_KEY = 'sb_publishable_eRID1BptpoH-t2xM7QEGyw_YQS_1ROb';

// Use hardcoded values first, then fall back to environment variables
const configUrl = HARDCODED_SUPABASE_URL || process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = HARDCODED_SUPABASE_ANON_KEY || process.env.REACT_APP_SUPABASE_ANON_KEY;

// Debug logging
console.log('Supabase Configuration:', {
  url: configUrl ? '✓ Set' : '✗ Missing',
  key: supabaseAnonKey ? '✓ Set' : '✗ Missing',
  urlValue: configUrl?.substring(0, 30) + '...',
});

// Check if credentials are missing or are placeholders
const isConfigured = configUrl && 
                     supabaseAnonKey && 
                     configUrl !== 'your_supabase_url_here' && 
                     supabaseAnonKey !== 'your_supabase_anon_key_here' &&
                     configUrl.startsWith('http');

if (!isConfigured) {
  console.error('Missing Supabase environment variables. Please configure REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY in your .env file');
  console.error('Or uncomment and set HARDCODED_SUPABASE_URL and HARDCODED_SUPABASE_ANON_KEY in this file');
  console.error('Current values:', { 
    url: configUrl ? 'Set (but may be placeholder)' : 'Missing',
    key: supabaseAnonKey ? 'Set (but may be placeholder)' : 'Missing'
  });
} else {
  console.log('Supabase configured successfully');
}

// Use a valid placeholder URL format to prevent crashes, but it won't work for actual API calls
// User must configure real credentials in .env file or hardcode them above
const finalUrl = isConfigured ? configUrl : 'https://placeholder.supabase.co';
const finalKey = isConfigured ? supabaseAnonKey : 'placeholder-key';

export const supabase = createClient(finalUrl, finalKey);
/** Base Supabase URL (no trailing slash). Use for Edge Function URLs. */
export const supabaseUrl = finalUrl.replace(/\/$/, '');
